<template>
  <div class="panel panel-grey m-b-xl">
    <div class="panel-body">
      <h3 class="m-t-none">Tagline</h3>
      <p>Describe yourself in a few words. This will be visible below your name when your profile is viewed.</p>

      <div :class="$v.stateTagline.$invalid ? 'has-error' : ''">
        <input
          name="tagline"
          type="text"
          class="form-control"
          v-model="$v.stateTagline.$model">

        <p class="help-block">{{ charactersRemaining }} Characters Left</p>
      </div>
    </div>

    <div class="panel-footer">
      <ladda-button
        class="btn btn-sm btn-primary"
        :click="handleUpdateTagline">
        Save Changes
      </ladda-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/users'
import { notify } from 'utils'
import { handleServerErrors } from 'utils/http'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [stateMapper],

  validations: {
    stateTagline: {
      maxLength: maxLength(30)
    }
  },

  computed: {
    charactersRemaining () {
      return 30 - (this.user.profile.tagline === null ? 0 : this.user.profile.tagline.length)
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleUpdateTagline () {
      if (this.$v.$invalid) {
        notify.error('Validation failed')
        return Promise.resolve()
      }
      return this.updateUser({
        id: this.user.id,
        payload: {
          profile: {
            tagline: this.user.profile.tagline
          }
        }
      }).then(() => {
        notify.success('Successfully saved tagline.')
      }).catch((errors) => {
        if (errors.response) {
          handleServerErrors(errors, this.errors)
        } else {
          notify.error('Sorry something has gone wrong, please try again.')
          throw errors
        }
      })
    }
  }
}
</script>
